import React from 'react';
import { tabsData } from './constants';
import style from './SectionDescktopWitsml.module.css';
import Tag from '../UIkit/Tag';
import WitsmlList from './WitsmlList';

export default function SectionDescktopWitsml() {
  return (
    <div className={style.container + ' dark'}>
      <div className={style.oval}></div>
      <div className={style.inner}>
        <div className={style.titlebox}>
          <h2 className={style.title}>INNERICA WITSML</h2>
          <Tag className={style.tag} title="2 сценария развертывания" color="white" />
        </div>
        <div className={style.tabs}>
          <div className={style.tab}>
            <div className={style.tabtitle}>{tabsData.witsml.title}</div>
            <WitsmlList list={tabsData.witsml.items} />
            <span className={style.num}>1</span>
          </div>
          <div className={style.tab}>
            <div className={style.tabtitle}>{tabsData.innerica.title}</div>
            <WitsmlList list={tabsData.innerica.items} />
            <span className={style.num}>2</span>
          </div>
        </div>
      </div>
    </div>
  );
}
